export default __webpack_public_path__ + "static/media/7-charts_announcement.d1299a87.svg";